import { createContext, useContext } from "react";
import type { MetadataReference, MetadataValues } from "../../../lib/schedule-presets/metadata-schema";

export const MetadataFormContext = createContext<{
  values: MetadataValues;
  references: MetadataReference[];
  renameFormat?: (name: string, nextName: string) => boolean;
}>({ values: {}, references: [] });

export const useMetadataForm = () => useContext(MetadataFormContext);
